module.exports = __webpack_public_path__ + "r-v3/img/close_off.2aba3eb1.svg";